import React from 'react';
import PropTypes from 'prop-types';
import { Tag, Divider, Avatar, Card, Typography, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { commuteOptions } from 'utils/shifts';
import { getLabel } from 'utils/labels';
import { sectors } from 'utils/roles-sectors';

import './style.css';

const tagColors = [
  // 'magenta',
  // 'volcano',
  // 'orange',
  // 'gold',
  // 'lime',
  // 'green',
  // 'cyan',
  'blue',
  // 'geekblue',
  // 'purple',
];

const WorkerCard = ({
  id,
  info,
  mainAddress,
  experience,
  isFakeUser,
  shiftsInfo,
  jobRoles,
}) => {
  const history = useHistory();
  const { hourRate, travelOptions } = shiftsInfo;

  const jobTags = new Set(
    Object.values(jobRoles).map((item) => {
      return getLabel(item.sector, sectors);
    })
  );

  const fakeUserName = () => {
    return `Worker-${Math.round(Math.random() * 10000000)}`;
  };

  return (
    <Card
      className="worker-search-card"
      onClick={() => {
        history.push(`/worker-detail/${id}`);
      }}
    >
      <Card.Meta
        avatar={
          <Avatar
            size={80}
            src={info.photoURL}
            style={{ filter: 'blur(5px)' }}
          />
        }
        // title={`${info.firstName} ${info.lastName}`}
        // title={fakeUserName()}
        description={
          <Typography>
            <p>
              <strong>Rate</strong>
              <br />£{hourRate[0]} - £{hourRate[1]}
            </p>
            <p>
              <strong>Commute</strong>
              <br />
              {mainAddress.postCode.toUpperCase()} •{' '}
              {commuteOptions[travelOptions].label}
            </p>
            <Button type="primary">More</Button>
          </Typography>
          // <Typography.Paragraph ellipsis={{ rows: 2 }}>
          //   {experience.text}
          // </Typography.Paragraph>
        }
      />
      <Divider />

      <section className="worker-search-card-tags">
        {[...jobTags].map((tag, i) => {
          return (
            <Tag
              color={tagColors[Math.floor(Math.random() * tagColors.length)]}
              key={i}
            >
              {tag}
            </Tag>
          );
        })}

        {isFakeUser ? (
          <Tag icon={<ExclamationCircleOutlined />} color="warning">
            Fake User
          </Tag>
        ) : null}
      </section>
    </Card>
  );
};

WorkerCard.propTypes = {
  id: PropTypes.string.isRequired,
  info: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    photoURL: PropTypes.string.isRequired,
  }).isRequired,
  experience: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }),
  mainAddress: PropTypes.shape({
    postCode: PropTypes.string,
  }).isRequired,
  mandatoryCourses: PropTypes.shape({}).isRequired,
  qualifications: PropTypes.shape({}).isRequired,
  isFakeUser: PropTypes.bool,
  shiftsInfo: PropTypes.shape({
    hourRate: PropTypes.shape({
      '0': PropTypes.number,
      '1': PropTypes.number,
    }),
    travelOptions: PropTypes.number,
  }).isRequired,
  jobRoles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

WorkerCard.defaultProps = {
  isFakeUser: false,
  experience: {
    text: 'not set',
  },
};

export default WorkerCard;
